<div class="flex gap-x-[12px]">
  <div class="flex flex-col items-center justify-center">
    <span
      [class]="
        twMerge(
          ' rounded-full bg-emerald-500 h-[24px] w-[24px] bg-white flex border-[2px] heading-12 border-blue-gray-500 items-center
          justify-center flex-shrink-0',
          activeStepper?.workflowName === option.workflowName ||
            activeStepper?.secondaryWorkflowName === option.workflowName
            ? 'bg-white border-emerald-600'
            : '',
          option.isCompleted ? 'bg-emerald-500 border-emerald-600' : '',
          option.requestStatus === STATUS.REJECT && !option.isCompleted ? 'bg-red-500 border-red-600' : ''
        )
      "
    >
      @if (option.isCompleted) {
        <lib-check-icon class="fill-white" />
      }
      @if (option.requestStatus === STATUS.REJECT && !option.isCompleted) {
        <lib-sync-icon />
      }
    </span>
    <span
      [class]="
        twMerge(
          'block h-full w-[2px] bg-blue-gray-500',
          option.isCompleted ? 'bg-emerald-600' : '',
          option.isLastElement ? 'invisible' : ''
        )
      "
    ></span>
  </div>

  <span class="heading-12 text-black font-medium pt-[4px] pb-[24px]">
    {{ option.workflowName }}
    @if (
      (option.requestStatus === STATUS.REJECT ||
      option.requestStatus === FDP_STATUS.REJECTED) &&
      !option.isCompleted
    ) {
      <p class="heading-12 text-gray-500 font-medium">Rejected by {{ option.focal }}</p>
    } @else if (
      (option.workflowName === STEPPER.PENDING_REVIEW_TP_TRC_AM ||
      option.workflowName === STEPPER.PENDING_REVIEW_APPROVER ||
      option.workflowName === FDP_STEPPER.PROGRESS_REVIEW) &&
      option.isCompleted
    ) {
      <p class="heading-12 text-gray-500 font-medium">Approved by {{ option.focal }}</p>
    }
  </span>
</div>
